export default {
  //home: require('./page/Home'),
  settings: require('./page/Settings'),
  privacy: require('./page/Privacy'),
  terms: require('./page/Terms'),
  about: require('./page/AboutPage'),
  post: require('./cms/PostPage'),
}
